import {
  useNaviparkApiClient as useCustomFetch,
  UseFetchOptions,
} from '@/repositories/client/useNaviparkApiClient';

const resource = 'push';

export const PushRepository = () => {
  /**
   * Push通知を開封したこと通知
   * @method POST
   * @param pushId プッシュ通知ID
   */
  const open = (pushId: number, options?: UseFetchOptions<void>) => {
    return useCustomFetch<void>('POST', `${resource}/${pushId}/open`, {
      ...options,
    });
  };

  return {
    open,
  };
};
